import { preview } from '@/components/form/preview'

import { Header } from './components/Header'
import { useTexts } from './hooks/useTexts'

type SingleViewProps = {
  depot: uui.domain.client.rm.Depot
}

function isNull(value: number) {
  return value <= 0
}

export function SinglePreview(props: SingleViewProps) {
  const { depot } = props
  const { labels } = useTexts()

  return (
    <preview.Root applyPendingFitMapOnMount header={<Header depot={depot} />}>
      <preview.Field label={labels.address}>{depot.location.address}</preview.Field>

      <preview.Divider />

      <preview.Field label={labels.setupCost}>
        <preview.CurrencyValue isNull={isNull}>{depot.setupCost / 100}</preview.CurrencyValue>
      </preview.Field>

      <preview.Field label={labels.setupTime}>
        <preview.DurationValue isNull={isNull}>{depot.setupTimeSec}</preview.DurationValue>
      </preview.Field>
    </preview.Root>
  )
}
